/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AddressDto, CreateOrUpdateAddressRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiUserAddressesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-user-addresses-controller
   * @name CreateOrUpdateAddressForUser
   * @request PUT:/api/v1/reimbursement/user/addresses/{addressType}
   */
  createOrUpdateAddressForUser = (
    addressType: string,
    data: CreateOrUpdateAddressRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AddressDto, any>({
      path: `/v1/reimbursement/user/addresses/${addressType}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrUpdateAddressForUserPath = '/v1/reimbursement/user/addresses/${addressType}'
  static createOrUpdateAddressForUserMethod = 'PUT'
}
